import React from 'react';
import { Plus } from '../../../bravosIcons';

type MembersEmptyHeroProps = {
  onInvite: () => void;
};

/** Decorative preview rows — non-interactive (State A hero). */
const MOCK_ROWS = [
  {
    initials: 'JD',
    name: 'Jordan Diaz',
    email: 'jordan.diaz@email.com',
    badge: 'active' as const,
    badgeLabel: 'Active',
    strip: [40, 70, 55, 90, 65],
  },
  {
    initials: 'RK',
    name: 'Riley Khan',
    email: 'riley.khan@email.com',
    badge: 'active' as const,
    badgeLabel: 'Active',
    strip: [55, 30, 75, 45, 80],
  },
  {
    initials: 'SP',
    name: 'Sam Petrov',
    email: 'sam.petrov@email.com',
    badge: 'warn' as const,
    badgeLabel: 'Needs attention',
    strip: null,
  },
];

export const MembersEmptyHero: React.FC<MembersEmptyHeroProps> = ({ onInvite }) => {
  return (
    <div className="empty-hero" data-testid="members-empty-hero">
      <div className="empty-hero-grid">
        <div>
          <div className="empty-eyebrow">
            <span className="dot" aria-hidden />
            Your roster starts here
          </div>
          <h2 className="empty-title">Invite your first member</h2>
          <p className="empty-desc">
            Members show up here once they accept your invite. Send one now — they&apos;ll get an
            email with a link to join and set up their account. You can track their training,
            consistency, and plans right from this page.
          </p>
          <button type="button" className="btn-primary" onClick={onInvite}>
            <Plus width={14} height={14} aria-hidden />
            Invite member
          </button>
        </div>
        <div aria-hidden="true">
          <div className="empty-mock-label">A member looks like</div>
          <div className="empty-mock-stack">
            {MOCK_ROWS.map((row) => (
              <div key={row.email} className="empty-mock-row">
                <div className="empty-mock-avatar">{row.initials}</div>
                <div className="empty-mock-meta">
                  <div className="empty-mock-name">{row.name}</div>
                  <div className="empty-mock-sub">{row.email}</div>
                </div>
                <span className={`empty-mock-badge ${row.badge}`}>{row.badgeLabel}</span>
                {row.strip && (
                  <span className="empty-mock-strip">
                    {row.strip.map((h, i) => (
                      <span key={i} style={{ height: `${h}%` }} />
                    ))}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
